import React from 'react'
import styles from '../../Header/header-widget/index.module.scss'

export const HeaderWidgetContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.widgetHeaderContainer}>{children}</div>
}
